const path = /^\d+$/
/**
 *
 * @param number
 */
function isNumber(number: string): boolean {
  return path.test(number)
}

export default isNumber
